import { render, staticRenderFns } from "./DCView.vue?vue&type=template&id=298e7838&scoped=true"
import script from "./DCView.vue?vue&type=script&lang=js"
export * from "./DCView.vue?vue&type=script&lang=js"
import style0 from "./DCView.vue?vue&type=style&index=0&id=298e7838&lang=scss&scoped=true"
import style1 from "./DCView.vue?vue&type=style&index=1&id=298e7838&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298e7838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298e7838')) {
      api.createRecord('298e7838', component.options)
    } else {
      api.reload('298e7838', component.options)
    }
    module.hot.accept("./DCView.vue?vue&type=template&id=298e7838&scoped=true", function () {
      api.rerender('298e7838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/DC/DCView.vue"
export default component.exports